import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrganizationViewModel, PageViewModel } from 'src/app/_models/generatedModels';
import { AnalyticsService } from 'src/app/_services/analytics.service';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { OrganizationCMSService, OrganizationService } from 'src/app/_services/generatedServices';
import { NavigationService } from 'src/app/_services/navigation-service';
import { SettingsProvider } from 'src/app/_services/settingsProvider.service';

@Component({
  selector: 'bxl-organization-layout',
  templateUrl: 'organization-layout.component.html',
})
export class OrganizationLayoutComponent implements OnInit {
  initialized = false;
  organizationId: string;
  organization: OrganizationViewModel;
  isCompanyAdmin: boolean;
  pages: PageViewModel[];
  constructor(private title: AnalyticsService, public auth: AuthenticationService, public settings: SettingsProvider, private route: ActivatedRoute, public nav: NavigationService, private router: Router, private cmsService: OrganizationCMSService, private orgService: OrganizationService) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.organizationId = params.get('organizationId');
      if (!this.organizationId) {
        this.organizationId = window.location.hostname.split('.').slice(0, -2).join('.');
      }

      console.log('orgId: ' + this.organizationId);

      this.orgService.getOrganization(this.organizationId).subscribe((organization) => {
        this.cmsService.getWebsitePagesForOrganization(this.organizationId).subscribe((pages) => {
          this.organization = organization;
          this.pages = pages;

          this.isCompanyAdmin = this.auth.isLoggedIn() && this.auth.isOrganizationAdmin(this.organization.id);

          this.initialized = true;
        });
      });
    });

    if (this.auth.isLoggedIn()) {
      this.auth.fetchUserProfile().subscribe((result) => {
        this.initialized = true;
      });
    }
  }

  logout() {
    this.auth.logout();
  }
}
